require('./RAWizard.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
const classNames = require('classnames');
// @ actions
const formActions = require('react-redux-form').actions;
const RASuitabilityTestWizardActions = require('actions/RASuitabilityTestWizardActions');
// @ components
const RATestNavigation = require('components/RAComponents/RAWizard/RATestNavigation');
const ActionLink = require('components/actionLink');

class RAWizardComponent extends React.Component {
    constructor(props) {
        super(props);

        this.handleChangeSubStep = this.handleChangeSubStep.bind(this);
        this.handleChangeStep = this.handleChangeStep.bind(this);
    }

    handleChangeSubStep(key, index) {
        const { RATestWizard, raWizardActions } = this.props;
        const finished = RATestWizard.steps?.[key].steps?.[index].finished;
        const available = RATestWizard.steps?.[key].steps?.[index].available;

        if (finished || available) {
            const data = {
                key,
                index,
            };
            raWizardActions.goToSubStep(data);
        }
    }

    handleChangeStep(index) {
        const { RATestWizard, raWizardActions } = this.props;
        const finished = RATestWizard.steps?.[index].finished;
        const available = RATestWizard.steps?.[index].available;

        if (finished || available) {
            raWizardActions.goToStep(index);
        }
    }

    render() {
        const { RATestWizard } = this.props;
        const { steps } = RATestWizard;
        const { currentStep } = RATestWizard;

        return (
            <div className="ra-wizard">
                <ul>
                    {steps.map((step, index) => {
                        const active = step.available;
                        const { finished } = step;
                        const { icon } = step;
                        const position = index === currentStep;
                        const classSubmenu = classNames(`submenu_${index}`, {
                            'active-menu': active && position,
                            'finished-menu': finished && !position,
                        });
                        const classIcon = classNames({
                            [`${icon}`]: !finished,
                            active: active && !finished,
                            finished,
                        });

                        return (
                            <li key={index} className={classSubmenu}>
                                <span
                                    className={classIcon}
                                    onClick={() => {
                                        this.handleChangeStep(index);
                                    }} // eslint-disable-line
                                ></span>
                                <RATestNavigation>
                                    {step.steps.map((substep, i) => {
                                        const hidden = substep.hidden;
                                        const subActive = substep.active;
                                        const subFinished = substep.finished;
                                        const classActive = classNames('navigation-li', {
                                            'navigation-li__active': subActive,
                                            'navigation-li__finished': subFinished,
                                            'navigation-li__hidden': hidden,
                                        });

                                        return (
                                            <ActionLink
                                                key={i}
                                                onClick={() => {
                                                    this.handleChangeSubStep(index, i);
                                                }} // eslint-disable-line
                                                onClickParams={[i]}
                                            >
                                                <li key={i} className={classActive}></li>
                                            </ActionLink>
                                        );
                                    })}
                                </RATestNavigation>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

RAWizardComponent.propTypes = {
    condensed: PropTypes.bool,
};

RAWizardComponent.defaultProps = {
    condensed: false,
};

export const RAWizard = connect(
    state => ({
        RATestWizard: state.raSuitabilityTestWizard,
    }),
    dispatch => ({
        raWizardActions: bindActionCreators(RASuitabilityTestWizardActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
    })
)(RAWizardComponent);
